import React, { useRef, useState } from "react";
import { ImagePlus, Loader2, Trash2 } from "lucide-react";
import api from "@/lib/api";

const mediaUrl = (value) => !value || value.startsWith("http") || value.startsWith("data:")
    ? value
    : `${process.env.REACT_APP_BACKEND_URL}${value}`;

export const AgencyLogoUpload = ({ value, onChange, testPrefix }) => {
    const inputRef = useRef(null);
    const [busy, setBusy] = useState(false);
    const [error, setError] = useState("");

    const upload = async (file) => {
        if (!file) return;
        setBusy(true);
        setError("");
        try {
            const formData = new FormData();
            formData.append("file", file);
            const { data } = await api.post("/profile/agency-logo", formData);
            onChange(data.logo_url);
        } catch (requestError) {
            setError(requestError?.response?.data?.detail || "Caricamento logo non riuscito");
        } finally {
            setBusy(false);
        }
    };

    const remove = async () => {
        setBusy(true);
        setError("");
        try {
            await api.delete("/profile/agency-logo");
            onChange("");
        } catch (requestError) {
            setError(requestError?.response?.data?.detail || "Rimozione logo non riuscita");
        } finally {
            setBusy(false);
        }
    };

    return (
        <div data-testid={`${testPrefix}-logo-upload`} className="flex flex-col sm:flex-row gap-5 items-start">
            <div data-testid={`${testPrefix}-logo-preview`} className="logo-preview-checkerboard inline-flex shrink-0 items-center justify-center border border-white/15 p-2 max-w-full">
                {value ? (
                    <img
                        data-testid={`${testPrefix}-logo-preview-image`}
                        src={mediaUrl(value)}
                        alt="Anteprima logo agenzia"
                        className="block w-auto h-auto max-w-[70vw] sm:max-w-72 max-h-32 object-contain object-center"
                    />
                ) : (
                    <span className="w-28 h-20 grid place-items-center"><ImagePlus size={30} className="text-slate-500" /></span>
                )}
            </div>
            <div className="flex-1 min-w-0">
                <input
                    ref={inputRef}
                    data-testid={`${testPrefix}-logo-file-input`}
                    type="file"
                    accept=".png,.svg,image/png,image/svg+xml"
                    className="hidden"
                    onChange={(event) => { upload(event.target.files?.[0]); event.target.value = ""; }}
                />
                <div className="flex flex-wrap gap-3">
                    <button data-testid={`${testPrefix}-logo-upload-button`} type="button" disabled={busy} onClick={() => inputRef.current?.click()} className="cta-outline min-h-11 px-4 text-xs flex items-center gap-2 disabled:opacity-50">
                        {busy ? <Loader2 size={14} className="animate-spin" /> : <ImagePlus size={14} />}
                        {value ? "Sostituisci logo" : "Carica logo"}
                    </button>
                    {value && (
                        <button data-testid={`${testPrefix}-logo-remove-button`} type="button" disabled={busy} onClick={remove} className="min-h-11 px-4 text-xs flex items-center gap-2 border border-red-700/40 text-red-300 hover:bg-red-900/20 disabled:opacity-50">
                            <Trash2 size={14} /> Rimuovi
                        </button>
                    )}
                </div>
                <p data-testid={`${testPrefix}-logo-help`} className="text-xs text-ink-500 mt-3">PNG o SVG, massimo 2 MB. Il caricamento aggiorna subito il profilo pubblico.</p>
                {error && <p data-testid={`${testPrefix}-logo-error`} className="text-xs text-red-300 mt-3">{error}</p>}
            </div>
        </div>
    );
};